/**
 * IndexedDB setup using Dexie for offline storage
 */
import Dexie from 'dexie'

export class DrillTimerDatabase extends Dexie {
  constructor() {
    super('DrillTimerDB')

    // Define database schema
    this.version(1).stores({
      pendingReports: '++id, status, queuedAt',
      cachedTemplates: 'id, cachedAt',
      cachedUsers: 'id, cachedAt',
    })

    // Type the tables
    this.pendingReports = this.table('pendingReports')
    this.cachedTemplates = this.table('cachedTemplates')
    this.cachedUsers = this.table('cachedUsers')
  }
}

// Create singleton instance
export const db = new DrillTimerDatabase()

/**
 * @typedef {Object} PendingReport
 * @property {number} [id] - Auto-incremented ID
 * @property {Object} reportData - The drill timer log data
 * @property {Date} queuedAt - When it was queued
 * @property {'pending'|'syncing'|'failed'} status - Current status
 * @property {string} [error] - Error message if failed
 * @property {number} retryCount - Number of retry attempts
 */

/**
 * @typedef {Object} CachedTemplate
 * @property {string} id - Template ID
 * @property {Object} data - Template data
 * @property {Date} cachedAt - When it was cached
 */

/**
 * @typedef {Object} CachedUser
 * @property {string} id - User ID
 * @property {Object} data - User data
 * @property {Date} cachedAt - When it was cached
 */
